// @mui
import Container from '@mui/material/Container';
// hooks
// _mock
// components
import { useSettingsContext } from 'src/components/settings';
import MaintainaceCreatePage from './maintainace-create-page';
// assets
//

// ----------------------------------------------------------------------

export default function CreateMaintainace() {
    // const { user } = useMockedUser();
    const settings = useSettingsContext();
    return (
        <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
            <MaintainaceCreatePage />
        </Container >
    );
}
